import { world } from '../../languages';
import isSupplementaryWorld from '../is-supplementary-world';

const de_big = require('./placeholders/big/noimage-de.png');
const es_big = require('./placeholders/big/noimage-es.png');
const fr_big = require('./placeholders/big/noimage-fr.png');
const gr_big = require('./placeholders/big/noimage-gr.png');
const it_big = require('./placeholders/big/noimage-it.png');
const de_small = require('./placeholders/small/noimage-de.png');
const es_small = require('./placeholders/small/noimage-es.png');
const fr_small = require('./placeholders/small/noimage-fr.png');
const gr_small = require('./placeholders/small/noimage-gr.png');
const it_small = require('./placeholders/small/noimage-it.png');
const defaultImage = require('./placeholders/noimage-common.png');

const placeholderMap = {
    big: {
        de: de_big,
        es: es_big,
        fr: fr_big,
        it: it_big,
        gr: gr_big
    },
    small: {
        de: de_small,
        es: es_small,
        fr: fr_small,
        it: it_small,
        gr: gr_small
    }
};

const shouldUseDefaultImage = isSupplementaryWorld();

const NoImage = shouldUseDefaultImage ? defaultImage : placeholderMap.small[world];

export const NoImageBig = shouldUseDefaultImage ? defaultImage : placeholderMap.big[world];

export default NoImage;
